export enum IPlanToolTipKey {
  RECORDED_REVENUE = 'RECORDED_REVENUE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  USAGE_FEE = 'USAGE_FEE',
  TEMPLATE_TESTING = 'TEMPLATE_TESTING',
  PRODUCT_PRICE_TESTING = 'PRODUCT_PRICE_TESTING',
  MULTIPAGE_TESTING = 'MULTIPAGE_TESTING',
  PATH_ANALYSIS = 'PATH_ANALYSIS',
  HEATMAP = 'HEATMAP',
  '60DAYS' = '60DAYS',
  '2YEARS' = '2YEARS',
}
